import { Img } from '@/components/blocks/MaterialImage';
import { Box } from '@mui/material';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';

interface ImageZoomViewerProps {
	src: string;
	alt?: string;
}

export interface ImageZoomViewerRef {
	resetTransform: () => void;
}

const ImageZoomViewer = forwardRef<ImageZoomViewerRef, ImageZoomViewerProps>(
	({ src, alt = '' }, ref) => {
		const zoomRef = useRef<ReactZoomPanPinchRef | null>(null);

		useImperativeHandle(ref, () => ({
			resetTransform: () => {
				if (zoomRef.current) {
					zoomRef.current.resetTransform();
				}
			},
		}));

		const handleClick = () => {
			if (!zoomRef.current) return;

			const { state, zoomIn, resetTransform } = zoomRef.current;

			if (state.scale === 1) {
				zoomIn(2, 200);
			} else {
				resetTransform();
			}
		};

		return (
			<Box sx={{ width: '100%', height: '100%', overflow: 'hidden' }}>
				<TransformWrapper
					ref={zoomRef}
					initialScale={1}
					doubleClick={{ disabled: false }}
					wheel={{ step: 0.2 }}
					pinch={{ disabled: false }}
					panning={{ disabled: false }}
					zoomAnimation={{ animationTime: 200 }}
					minScale={1}
					centerOnInit
				>
					<TransformComponent wrapperStyle={{ width: '100%', height: '100%' }}>
						<Img
							src={src}
							alt={alt}
							onClick={handleClick}
							sx={{
								width: '100%',
								height: '100%',
								objectFit: 'contain',
								cursor: 'zoom-in',
								touchAction: 'none',
								userSelect: 'none',
							}}
						/>
					</TransformComponent>
				</TransformWrapper>
			</Box>
		);
	}
);

export default ImageZoomViewer;
